import { Card, CardBody, Col, Row } from "reactstrap";
import { LiveProductsTitle } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ReactApexChart from "react-apexcharts";
import { LiveProductsChart } from "../../../../Data/General/Widgets/Chart";

const LiveProducts = () => {
  return (
    <Col xl="7" lg="12" className="xl-50">
      <div className="small-chart-widget chart-widgets-small">
        <Card>
          <CommonCardHeader title={LiveProductsTitle} />
          <CardBody>
            <div className="chart-container">
              <Row>
                <Col sx="12">
                  <div id="chart-widget6">
                    <ReactApexChart options={LiveProductsChart} series={LiveProductsChart.series} type="area" height={320} />
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default LiveProducts;
